module.exports = __webpack_public_path__ + "static/media/Pastores.04d90b99.jpg";